define('collections/calendar/items',[
    'underscore', 'backbone', 'utils',
    // models
    'models/calendar/item',
    'models/calendar/item/animated-session',
    'models/calendar/item/text-session',
    'models/calendar/item/nutrition',
    'models/calendar/item/personal-data',
], function(
    _, Backbone, U,
    // models
    MCalendarItem,
    MAnimatedSession,
    MTextSession,
    MNutrition,
    MPersonalData
) {

    var TYPES = {},
        ITEM_CONSTRUCTOR = [
            MAnimatedSession,
            MTextSession,
            MNutrition,
            MPersonalData
        ];

    var CCalendarItems = Backbone.Collection.extend({
        comparator: "date",
        /**
         * Different models based on the type attribute.
         * @param {Object} attrs   currently added model data
         * @param {Object} options
         * @param {MCalendarItem} subclass dependant of the type attribute.
         */
        model: function ModelFactory(attrs, options) {
            var ItemModel = CCalendarItems.getModel(attrs && attrs.type);
            return new ItemModel(attrs, options);
        },
        // fixes this.model.prototype.idAttribute and avoids duplicates
        modelId: function(attrs) {
            return attrs._id;
        },

        update: function(model, options) {
            return this.set(model, _.extend({ remove: false }, options));
        },

        updateSession: function(session, options) {
            if (session.hasReceivedChanges()) {
                var removed = session.getReceivedChanges().removed;
                if (removed) {
                    this.remove(removed, options);
                }
            }

            this.each(function(model) {
                if (model.get("session") === session.id) {
                    model.updateSession(session, options);
                }
            });

            return this;
        },

    }, {
        getModel: function(type) {
            return type ? TYPES[type] : MCalendarItem;
        }
    });

    // init TYPES hash
    _.each(ITEM_CONSTRUCTOR, function(ItemModel) {
        TYPES[ItemModel.type] = ItemModel;
    });

    return CCalendarItems;
});

